import type { Dispatch } from 'redux';
import type { AuthState, AuthAction } from '@/redux/auth/types';

export enum Actions {
  SetAuthData = 'SetAuthData',
  SetAuthDataFail = 'SetAuthDataFail'
}

export const setAuthData =
  (data: AuthState) => (dispatch: Dispatch<AuthAction>) => {
    const { refreshExpiresAt, accessExpiresAt, refreshToken, accessToken } =
      data;

    refreshExpiresAt
      ? localStorage.setItem('refreshExpiresAt', `${refreshExpiresAt}`)
      : localStorage.removeItem('refreshExpiresAt');

    accessExpiresAt
      ? localStorage.setItem('accessExpiresAt', `${accessExpiresAt}`)
      : localStorage.removeItem('accessExpiresAt');

    refreshToken
      ? localStorage.setItem('refreshToken', refreshToken)
      : localStorage.removeItem('refreshToken');

    accessToken
      ? localStorage.setItem('accessToken', accessToken)
      : localStorage.removeItem('accessToken');

    try {
      dispatch({ type: Actions.SetAuthData, data });
    } catch (error) {
      dispatch({ type: Actions.SetAuthDataFail, error });
    }
  };
